// Simple HUME EVI One-Way TTS Service for Encouragement
// This service only speaks - no bidirectional conversation or tools

class HumeSimpleTTS {
  constructor() {
    this.isConnected = false;
    this.voiceHook = null;
    this.spokenMilestones = new Map(); // Track per game
    this.cooldownMs = 2000; // Prevent audio overlap
    this.lastSpeakTime = 0;
    
    // Encouragement messages for different milestones
    this.messages = {
      5: [
        "Excellent start! Keep it up!",
        "Five down, great work!",
        "Fantastic beginning!"
      ],
      10: [
        "Ten reps! You're doing amazing!",
        "Great progress! Keep going!",
        "Wonderful work!"
      ],
      15: [
        "Fifteen! You're halfway there!",
        "Incredible effort!",
        "You're crushing it!"
      ],
      20: [
        "Twenty reps! Almost done!",
        "Outstanding performance!",
        "You're so close!"
      ],
      25: [
        "Twenty-five! Champion!",
        "Amazing job! You did it!",
        "Incredible achievement!"
      ],
      30: [
        "Thirty! You're a superstar!",
        "Absolutely fantastic!",
        "Beyond amazing!"
      ]
    };
  }

  // Initialize with HUME voice hook from EVI
  init(voiceHook) {
    this.voiceHook = voiceHook;
    this.isConnected = true;
    
  }
  
  // Disconnect and cleanup
  disconnect() {
    this.isConnected = false;
    this.voiceHook = null;
    this.spokenMilestones.clear();
    
  }

  // Speak encouragement at rep milestones
  speakEncouragement(reps, gameName = 'game') {
    // Check if we can speak via HUME or fallback to browser TTS
    const canUseHume = this.isConnected && this.voiceHook;
    
    if (!canUseHume) {
      
      // Fallback to browser TTS
      return this.speakWithBrowserTTS(reps, gameName);
    }
    
    // Check cooldown to prevent overlap
    const now = Date.now();
    if (now - this.lastSpeakTime < this.cooldownMs) {
      
      return false;
    }
    
    // Check if this milestone was already spoken for this game
    const key = `${gameName}_${reps}`;
    if (this.spokenMilestones.has(key)) {
      return false;
    }
    
    // Get message for this milestone
    const messages = this.messages[reps];
    if (!messages) {
      return false; // No message for this rep count
    }
    
    // Pick a random message
    const message = messages[Math.floor(Math.random() * messages.length)];
    
    // Speak through HUME
    try {
      if (this.voiceHook.sendAssistantInput) {
        this.voiceHook.sendAssistantInput(message);
        this.spokenMilestones.set(key, true);
        this.lastSpeakTime = now;
        
        return true;
      }
    } catch (error) {
      console.error('🎤 Error speaking encouragement:', error);
    }
    
    return false;
  }
  
  // Reset milestones for a new game session
  resetGame(gameName) {
    // Clear all milestones for this game
    const keysToDelete = [];
    for (const key of this.spokenMilestones.keys()) {
      if (key.startsWith(`${gameName}_`)) {
        keysToDelete.push(key);
      }
    }
    keysToDelete.forEach(key => this.spokenMilestones.delete(key));
    
  }
  
  // Check if a specific milestone was spoken
  wasSpoken(reps, gameName = 'game') {
    return this.spokenMilestones.has(`${gameName}_${reps}`);
  }
  
  // Browser TTS fallback
  speakWithBrowserTTS(reps, gameName = 'game') {
    // Check if already spoken
    const key = `${gameName}_${reps}`;
    if (this.spokenMilestones.has(key)) {
      return false;
    }
    
    // Get message for this milestone
    const messages = this.messages[reps];
    if (!messages) {
      return false;
    }
    
    // Pick a random message
    const message = messages[Math.floor(Math.random() * messages.length)];
    
    // Use browser's built-in TTS
    try {
      const utterance = new SpeechSynthesisUtterance(message);
      utterance.rate = 1.0;
      utterance.pitch = 1.0;
      utterance.volume = 0.9;
      
      // Cancel any ongoing speech
      window.speechSynthesis.cancel();
      window.speechSynthesis.speak(utterance);
      
      this.spokenMilestones.set(key, true);
      this.lastSpeakTime = Date.now();
      
      
      return true;
    } catch (error) {
      console.error('❌ Browser TTS error:', error);
      return false;
    }
  }
  
  // Get connection status
  getStatus() {
    return {
      connected: this.isConnected,
      hasVoiceHook: !!this.voiceHook,
      milestonesSpoken: this.spokenMilestones.size,
      browserTTSAvailable: 'speechSynthesis' in window
    };
  }
}

// Create global instance
const humeSimpleTTS = new HumeSimpleTTS();

// Expose globally for easy access
window.humeSimpleTTS = humeSimpleTTS;

// Debug function to test voice
window.testVoice = () => {
  const status = humeSimpleTTS.getStatus();
  
  
  // Always try to speak - will use HUME or fallback to browser
  
  const success = humeSimpleTTS.speakEncouragement(5, 'Test');
  
  if (success) {
    
  } else {
    
  }
  
  return success;
};

// Test browser TTS directly
window.testBrowserTTS = () => {
  const msg = new SpeechSynthesisUtterance("Testing browser text to speech");
  window.speechSynthesis.speak(msg);
  
};



export default humeSimpleTTS;